import styled from 'styled-components';
import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
export const CalendarContainer = styled(ReactCalendar) `
  border: none;
  width: 280px;

  &&& {
    .react-calendar__navigation {
      margin-bottom: 0;
    }

    .react-calendar__navigation__label {
      color: #4B4B4B;
      font-size: 15px;
      font-weight: bold;
      text-transform: uppercase;
      flex-grow: 0;
    }
    .react-calendar__month-view__weekdays__weekday abbr {
      font-family: 'Ubuntu', sans-serif;
      text-decoration: none;
      font-size: 15px;
      text-transform: capitalize;
      color: #3C4FBE;
    }

    .react-calendar__tile--active {
      color: #FFFFFF;
      border: none;
    }

    .react-calendar__tile {
      font-family: 'Ubuntu', sans-serif;
      color: #4B4B4B;
      height: 38px;
      padding: 0;
      border: 1px solid white;
      font-size: 15px;
    }

    .react-calendar__tile--now {
      color: #1F35B5;
      background-color: transparent;
    }

    .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus{
        background-color: transparent;
      }

    .react-calendar__navigation button[disabled] {
      background-color: transparent;
    }

    .react-calendar__tile--range {
      background-color: #BBC2E9;
      color: white;
    }

    .react-calendar__tile--hover {
      background-color: #BBC2E9;
      color: white;
    }

    .react-calendar__tile--rangeStart, .react-calendar__tile--rangeEnd {
      background-color: #1F35B5;
      color: white;
    }
  }
`;
//# sourceMappingURL=styles.js.map